import { ChangeDetectionStrategy, Component, ViewEncapsulation, input, output, inject, computed } from '@angular/core';
import { AppTextService } from '../../../app-text';

@Component({
    selector: 'fi-new-report-widget-filter-settings-header',
    templateUrl: './fi-new-report-widget-filter-settings-header.component.html',
    styleUrls: ['./fi-new-report-widget-filter-settings-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-new-report-widget-filter-settings-header' },
    standalone: false,
})
export class FiNewReportWidgetFilterSettingsHeaderComponent {
    public widgetTypeName = input.required<string>();
    public backButtonClick = output<void>();

    private appTextService = inject(AppTextService);

    protected headerText = computed(() => {
        return this.appTextService.get('common.new_widget') + ' - ' + this.widgetTypeName();
    });
}
